/** @format */
import * as types from './actions';

const initialState = {
  addChartLoading: false, // {portcoId : { dashboardId : false/true }}
  addChartError: null, // {portcoId :{dashboardId : error_message }}
  updateChartTitleError: {}, // {portcoId : { dashboardId : error_message}}
  updateChartLoading: {},
  chartUpdateStatus: {}, // {portcoId : {dashboardId : { chartId : {message, error : message}}}
  recentlySharedPersons: {}, // {portcoId : {dashboardId : [{fullname,email_primary,nameOrEmail}]}
  dashboards: {}, // portcoId : {dashboards:[],error:null,loading:false}
  dashboardLoading: {},
  addDashboardStatus: {},
  loadDashboardStatus: {},
  removeDashboardStatus: {},
  updateDashboardStatus: {},
  deleteChartsStatus: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    /** ADD_CHART_TO_DASHBOARD */
    case types.ADD_CHART_TO_DASHBOARD_REQUEST:
      return Object.assign({}, state, {
        addChartLoading: true,
        addChartError: null,
      });
    case types.ADD_CHART_TO_DASHBOARD_SUCCESS: {
      const { portcoId, dashboardId, data } = payload;
      const newChartComponent = {
        component: { ...data, component: null },
        ...data?.component,
      };
      const existingDashboards = state.dashboards?.[portcoId]?.dashboards || [];

      const updatedDashboards = existingDashboards.map(dashboard => {
        if (dashboard.board?.id !== dashboardId) return dashboard;

        return {
          ...dashboard,
          board: {
            ...dashboard.board,
            components: [
              ...(dashboard.board?.components || []),
              newChartComponent,
            ],
          },
        };
      });

      return {
        ...state,
        addChartLoading: false,
        addChartError: null,
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            ...(state.dashboards[portcoId] || {}),
            dashboards: updatedDashboards,
          },
        },
      };
    }
    case types.ADD_CHART_TO_DASHBOARD_FAILURE:
      return Object.assign({}, state, {
        addChartLoading: false,
        addChartError: payload?.message,
      });

    case types.UPDATE_DASHBOARD_CHART_REQUEST: {
      const { portcoId, dashboardId, chartId } = payload;

      return {
        ...state,
        chartUpdateStatus: {
          ...state.chartUpdateStatus,
          [portcoId]: {
            ...state.chartUpdateStatus[portcoId],
            [dashboardId]: {
              ...(state.chartUpdateStatus[portcoId]?.[dashboardId] || {}),
              [chartId]: {
                loading: true,
                error: null,
              },
            },
          },
        },
      };
    }

    case types.UPDATE_DASHBOARD_CHART_SUCCESS: {
      const { portcoId, dashboardId, chartId, data } = payload;
      const updatedChartComponent = {
        component: { ...data, component: null },
        ...(data?.component || {}),
      };
      const existingDashboards = state.dashboards?.[portcoId]?.dashboards || [];

      const updatedDashboards = existingDashboards.map(dashboard => {
        if (dashboard.board?.id !== dashboardId) return dashboard;

        const updatedComponents =
          dashboard.board?.components?.map(comp => {
            if (comp.component?.id === chartId) {
              return updatedChartComponent;
            }
            return comp;
          }) || [];

        return {
          ...dashboard,
          board: {
            ...dashboard.board,
            components: updatedComponents,
          },
        };
      });

      return {
        ...state,
        chartUpdateStatus: {
          ...state.chartUpdateStatus,
          [portcoId]: {
            ...state.chartUpdateStatus[portcoId],
            [dashboardId]: {
              ...(state.chartUpdateStatus[portcoId]?.[dashboardId] || {}),
              [chartId]: {
                loading: false,
                error: null,
              },
            },
          },
        },
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            ...(state.dashboards[portcoId] || {}),
            dashboards: updatedDashboards,
          },
        },
      };
    }

    case types.UPDATE_DASHBOARD_CHART_FAILURE: {
      const { portcoId, dashboardId, chartId, message } = payload;

      return {
        ...state,
        chartUpdateStatus: {
          ...state.chartUpdateStatus,
          [portcoId]: {
            ...state.chartUpdateStatus[portcoId],
            [dashboardId]: {
              ...(state.chartUpdateStatus[portcoId]?.[dashboardId] || {}),
              [chartId]: {
                loading: false,
                error: message,
              },
            },
          },
        },
      };
    }

    case types.DELETE_CHART_FROM_DASHBOARD_REQUEST:
      return { ...state };
    case types.DELETE_CHART_FROM_DASHBOARD_SUCCESS: {
      const { portcoId, dashboardId, componentId } = payload;

      const existingDashboards = state.dashboards?.[portcoId]?.dashboards || [];

      const updatedDashboards = existingDashboards.map(dashboard => {
        if (dashboard.board?.id !== dashboardId) return dashboard;

        return {
          ...dashboard,
          board: {
            ...dashboard.board,
            components:
              dashboard.board?.components?.filter(
                component => component.component?.id !== componentId
              ) || [],
          },
        };
      });

      return {
        ...state,
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            ...(state.dashboards[portcoId] || {}),
            dashboards: updatedDashboards,
          },
        },
      };
    }

    case types.DELETE_CHART_FROM_DASHBOARD_FAILURE:
      return { ...state };
    case types.ADD_PORTFOLIO_DASHBOARD_REQUEST: {
      const { portcoId } = payload;

      return {
        ...state,
        addDashboardStatus: {
          ...state.addDashboardStatus,
          [portcoId]: {
            loading: true,
            error: null,
          },
        },
      };
    }

    case types.UPDATE_DASHBOARD_LAYOUT: {
      const { portcoId, dashboardId, data: updatedCoardinnates } = payload;
      // updatedCoardinnates are the coordinates of charts existing in a dashboard

      const existingDashboards = state.dashboards?.[portcoId]?.dashboards || [];

      const updatedDashboards = existingDashboards.map(dashboard => {
        if (dashboard.board?.id !== dashboardId) return dashboard;
        const updatedComponents =
          dashboard.board?.components?.map(chart => {
            const updatedChartCoordinates = updatedCoardinnates.find(
              c => c.id === chart.id
            );
            if (updatedChartCoordinates instanceof Object) {
              const updatedChart = { ...chart, ...updatedChartCoordinates };
              return updatedChart;
            }
            return chart;
          }) || [];

        return {
          ...dashboard,
          board: {
            ...dashboard.board,
            components: updatedComponents,
          },
        };
      });

      return {
        ...state,
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            ...(state.dashboards[portcoId] || {}),
            dashboards: updatedDashboards,
          },
        },
      };
    }

    case types.ADD_PORTFOLIO_DASHBOARD_SUCCESS: {
      const { portcoId, dashboard } = payload;

      const existingDashboards = state.dashboards?.[portcoId]?.dashboards || [];

      return {
        ...state,
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            dashboards: [...existingDashboards, dashboard],
            loading: false,
            error: null,
          },
        },
        addDashboardStatus: {
          ...state.addDashboardStatus,
          [portcoId]: {
            loading: false,
            error: null,
          },
        },
      };
    }

    case types.ADD_PORTFOLIO_DASHBOARD_FAILURE: {
      const { portcoId, message } = payload;

      return {
        ...state,
        addDashboardStatus: {
          ...state.addDashboardStatus,
          [portcoId]: {
            loading: false,
            error: message,
          },
        },
      };
    }

    case types.LOAD_PORTFOLIO_DASHBOARD_REQUEST: {
      const { portcoId, dashboardId } = payload;

      return {
        ...state,
        loadDashboardStatus: {
          ...state.loadDashboardStatus,
          [portcoId]: {
            ...(state.loadDashboardStatus[portcoId] || {}),
            [dashboardId]: {
              loading: true,
              error: null,
            },
          },
        },
      };
    }

    case types.LOAD_PORTFOLIO_DASHBOARD_SUCCESS: {
      const { portcoId, dashboardId, dashboard } = payload;

      const existingDashboards = state.dashboards?.[portcoId]?.dashboards || [];

      const updatedDashboards = (() => {
        const found = existingDashboards.some(d => d.board?.id === dashboardId);
        if (found) {
          return existingDashboards.map(d =>
            d.board?.id === dashboardId ? dashboard : d
          );
        }
        return [...existingDashboards, dashboard];
      })();

      return {
        ...state,
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            ...(state.dashboards[portcoId] || {}),
            dashboards: updatedDashboards,
          },
        },
        loadDashboardStatus: {
          ...state.loadDashboardStatus,
          [portcoId]: {
            ...(state.loadDashboardStatus[portcoId] || {}),
            [dashboardId]: {
              loading: false,
              error: null,
            },
          },
        },
      };
    }

    case types.LOAD_PORTFOLIO_DASHBOARD_FAILURE: {
      const { portcoId, dashboardId, message } = payload;

      return {
        ...state,
        loadDashboardStatus: {
          ...state.loadDashboardStatus,
          [portcoId]: {
            ...(state.loadDashboardStatus[portcoId] || {}),
            [dashboardId]: {
              loading: false,
              error: message,
            },
          },
        },
      };
    }

    case types.LOAD_PORTFOLIO_DASHBOARDS_REQUEST: {
      const { portcoId } = payload;

      return {
        ...state,
        dashboardLoading: {
          ...state.dashboardLoading,
          [portcoId]: true,
        },
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            ...(state.dashboards[portcoId] || {}),
            loading: true,
            error: null,
          },
        },
      };
    }

    case types.LOAD_PORTFOLIO_DASHBOARDS_SUCCESS: {
      const { portcoId, dashboards } = payload;

      return {
        ...state,
        dashboardLoading: {
          ...state.dashboardLoading,
          [portcoId]: false,
        },
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            dashboards,
            loading: false,
            error: null,
          },
        },
      };
    }

    case types.LOAD_PORTFOLIO_DASHBOARDS_FAILURE: {
      const { portcoId, message } = payload;

      return {
        ...state,
        dashboardLoading: {
          ...state.dashboardLoading,
          [portcoId]: false,
        },
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            dashboards: [],
            loading: false,
            error: message,
          },
        },
      };
    }

    case types.UPDATE_PORTFOLIO_DASHBOARD_REQUEST: {
      const { portcoId, dashboardId } = payload;
      return {
        ...state,
        updateDashboardStatus: {
          ...state.updateDashboardStatus,
          [portcoId]: {
            ...(state.updateDashboardStatus[portcoId] || {}),
            [dashboardId]: {
              loading: true,
              error: null,
            },
          },
        },
      };
    }

    case types.UPDATE_PORTFOLIO_DASHBOARD_SUCCESS: {
      const { portcoId, dashboardId, dashboard: updatedDashboard } = payload;

      const existingDashboards = state.dashboards?.[portcoId]?.dashboards || [];

      const updatedDashboards = existingDashboards.map(d => {
        if (d.board?.id !== dashboardId) return d;

        // Check if components exist in the updated dashboard
        const hasComponents = 'components' in updatedDashboard?.board;

        return hasComponents
          ? updatedDashboard
          : {
              ...updatedDashboard,
              board: {
                ...(updatedDashboard.board || {}),
                components: d.board?.components || [],
              },
            };
      });

      return {
        ...state,
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            ...(state.dashboards[portcoId] || {}),
            dashboards: updatedDashboards,
          },
        },
        updateDashboardStatus: {
          ...state.updateDashboardStatus,
          [portcoId]: {
            ...(state.updateDashboardStatus[portcoId] || {}),
            [dashboardId]: {
              loading: false,
              error: null,
            },
          },
        },
      };
    }

    case types.UPDATE_PORTFOLIO_DASHBOARD_FAILURE: {
      const { portcoId, dashboardId, message } = payload;

      return {
        ...state,
        updateDashboardStatus: {
          ...state.updateDashboardStatus,
          [portcoId]: {
            ...(state.updateDashboardStatus[portcoId] || {}),
            [dashboardId]: {
              loading: false,
              error: message,
            },
          },
        },
      };
    }

    case types.REMOVE_PORTFOLIO_DASHBOARD_REQUEST: {
      const { portcoId, dashboardId } = payload;

      return {
        ...state,
        removeDashboardStatus: {
          ...state.removeDashboardStatus,
          [portcoId]: {
            ...(state.removeDashboardStatus[portcoId] || {}),
            [dashboardId]: {
              loading: true,
              error: null,
            },
          },
        },
      };
    }

    case types.REMOVE_PORTFOLIO_DASHBOARD_SUCCESS: {
      const { portcoId, dashboardId } = payload;

      const updatedDashboards =
        state.dashboards?.[portcoId]?.dashboards?.filter(
          d => d.board?.id !== dashboardId
        ) || [];

      return {
        ...state,
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            ...(state.dashboards[portcoId] || {}),
            dashboards: updatedDashboards,
          },
        },
        removeDashboardStatus: {
          ...state.removeDashboardStatus,
          [portcoId]: {
            ...(state.removeDashboardStatus[portcoId] || {}),
            [dashboardId]: {
              loading: false,
              error: null,
            },
          },
        },
      };
    }

    case types.REMOVE_PORTFOLIO_DASHBOARD_FAILURE: {
      const { portcoId, dashboardId, message } = payload;

      return {
        ...state,
        removeDashboardStatus: {
          ...state.removeDashboardStatus,
          [portcoId]: {
            ...(state.removeDashboardStatus[portcoId] || {}),
            [dashboardId]: {
              loading: false,
              error: message,
            },
          },
        },
      };
    }

    case types.DUPLICATE_PORTFOLIO_DASHBOARD_REQUEST: {
      return { ...state };
    }
    case types.DUPLICATE_PORTFOLIO_DASHBOARD_SUCCESS: {
      const { portcoId, dashboard } = payload;

      const existingDashboards = state.dashboards?.[portcoId]?.dashboards || [];

      return {
        ...state,
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            dashboards: [...existingDashboards, dashboard],
            loading: false,
            error: null,
          },
        },
      };
    }
    case types.DUPLICATE_PORTFOLIO_DASHBOARD_FAILURE: {
      return { ...state };
    }

    case types.MOVE_CHART_TO_DASHBOARD_SUCCESS: {
      const {
        portcoId,
        dashboardId, // from this dashboard
        chartId, // chart to be moved
        dashboard_id_where_to_move, // to this dashboard
      } = payload;

      const existingDashboards = state.dashboards?.[portcoId]?.dashboards || [];

      let chartToMove = null;

      const updatedDashboards = existingDashboards.map(dashboard => {
        const currentDashboardId = dashboard.board?.id;

        if (currentDashboardId === dashboardId) {
          chartToMove =
            dashboard.board?.components?.find(
              component => component.component?.id === chartId
            ) || null;

          // Removing chart from source dashboard
          return {
            ...dashboard,
            board: {
              ...dashboard.board,
              components:
                dashboard.board?.components?.filter(
                  component => component.component?.id !== chartId
                ) || [],
            },
          };
        }

        return dashboard;
      });

      // Now that chartToMove is found, update destination dashboard
      const finalDashboards = updatedDashboards.map(dashboard => {
        if (dashboard.board?.id === dashboard_id_where_to_move && chartToMove) {
          return {
            ...dashboard,
            board: {
              ...dashboard.board,
              components: [...(dashboard.board?.components || []), chartToMove],
            },
          };
        }
        return dashboard;
      });

      return {
        ...state,
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            ...(state.dashboards[portcoId] || {}),
            dashboards: finalDashboards,
          },
        },
      };
    }

    case types.MOVE_CHART_TO_DASHBOARD_REQUEST:
    case types.MOVE_CHART_TO_DASHBOARD_FAILURE:
      return { ...state };

    case types.CONVERT_OLD_CHART_TO_NEW_CHART: {
      const { portcoId, dashboardId, chartId, chart } = payload;
      const newChartComponent = {
        component: { ...chart, component: null },
        ...chart?.component,
      };

      const existingDashboards = state.dashboards?.[portcoId]?.dashboards || [];

      const updatedDashboards = existingDashboards.map(dashboard => {
        if (dashboard.board?.id !== dashboardId) return dashboard;

        const updatedComponents = (dashboard.board?.components || []).map(
          comp => {
            const compId = comp.id;
            if (compId === chartId) {
              return newChartComponent;
            }
            return comp;
          }
        );

        return {
          ...dashboard,
          board: {
            ...dashboard.board,
            components: updatedComponents,
          },
        };
      });

      return {
        ...state,
        dashboards: {
          ...state.dashboards,
          [portcoId]: {
            ...(state.dashboards[portcoId] || {}),
            dashboards: updatedDashboards,
          },
        },
      };
    }

    case types.UPDATE_RECENTLY_SHARED_PEOPLE: {
      const { portcoId, dashboardId, people = [] } = payload;

      const existing =
        state.recentlySharedPersons?.[portcoId]?.[dashboardId] || [];

      const merged = [...people, ...existing];

      const uniqueByEmail = [];
      const seenEmails = new Set();

      for (const person of merged) {
        const email = person?.email_primary;
        if (email && !seenEmails.has(email)) {
          seenEmails.add(email);
          uniqueByEmail.push(person);
        }
      }
      // Keeping a max of 10 recent users, also avoiding duplicates by email_primary.
      const slicedPersons = uniqueByEmail.slice(0, 10);

      return {
        ...state,
        recentlySharedPersons: {
          ...state.recentlySharedPersons,
          [portcoId]: {
            ...(state.recentlySharedPersons[portcoId] || {}),
            [dashboardId]: slicedPersons,
          },
        },
      };
    }

    // case types.CLEAR_CHARTS:
    //   return Object.assign({}, state, initialState);

    default:
      return state;
  }
};
